/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Save_TitleInputs */

const en_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Transcript Export Preset`)
};

const fr_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le prereglage d'exportation de transcription`)
};

const de_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript speichern Exportvorgabe`)
};

const it_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva trascrizione Esporta preimpostazione`)
};

const ru_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить расшифровку Экспорт настроек`)
};

const es_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar transcripción Exportar ajuste preestablecido`)
};

const zh_cn2_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存转录导出预设`)
};

const ja_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトエクスポートプリセットを保存`)
};

const hi_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट निर्यात प्रीसेट सहेजें`)
};

const pt_pt2_transcript_export_preset_save_title = /** @type {(inputs: Transcript_Export_Preset_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar transcrição Exportar predefinição`)
};

/**
* | output |
* | --- |
* | "Save Transcript Export Preset" |
*
* @param {Transcript_Export_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_save_title = /** @type {((inputs?: Transcript_Export_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_save_title(inputs)
	if (locale === "de") return de_transcript_export_preset_save_title(inputs)
	if (locale === "it") return it_transcript_export_preset_save_title(inputs)
	if (locale === "ru") return ru_transcript_export_preset_save_title(inputs)
	if (locale === "es") return es_transcript_export_preset_save_title(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_save_title(inputs)
	if (locale === "ja") return ja_transcript_export_preset_save_title(inputs)
	if (locale === "hi") return hi_transcript_export_preset_save_title(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_save_title(inputs)
	return en_transcript_export_preset_save_title(inputs)
});